// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"46bd399469025f262fb9","303":"74a84b2460d7e2dd9efb","495":"69bd4930a584d6191014"}[chunkId] + ".js";
};